function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  className: "Icon-L-Close_svg__b"
}, /*#__PURE__*/React.createElement("path", {
  className: "Icon-L-Close_svg__d",
  d: "M13.414 12l5.293-5.293a1 1 0 00-1.414-1.414L12 10.586 6.707 5.293a1 1 0 00-1.414 1.414L10.586 12l-5.293 5.293a1 1 0 101.414 1.414L12 13.414l5.293 5.293a1 1 0 001.414-1.414z"
}));

var SvgIconLClose = function SvgIconLClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 24 24"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyNCAyNCI+PGRlZnM+PHN0eWxlPi5he2ZpbGw6cmVkO308L3N0eWxlPjwvZGVmcz48ZyBjbGFzcz0iYiI+PHBhdGggY2xhc3M9ImQiIGQ9Ik0xMy40MTQsMTJsNS4yOTMtNS4yOTNhMSwxLDAsMCwwLTEuNDE0LTEuNDE0TDEyLDEwLjU4Niw2LjcwNyw1LjI5M0ExLDEsMCwwLDAsNS4yOTMsNi43MDdMMTAuNTg2LDEyLDUuMjkzLDE3LjI5M2ExLDEsMCwxLDAsMS40MTQsMS40MTRMMTIsMTMuNDE0bDUuMjkzLDUuMjkzYTEsMSwwLDAsMCwxLjQxNC0xLjQxNFoiLz48L2c+PC9zdmc+Cg==";
export { SvgIconLClose as ReactComponent };